document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('quote_submitted') !== 'true') return;

  const modal = document.querySelector('[data-wb-rfq-modal]');
  const form = modal?.querySelector('.wb-quote form');
  if (!modal || !form) return;

  form.innerHTML = '<div class="wb-quote__success" role="status"><strong>Request submitted successfully.</strong><br>Thank you. Our team will contact you soon.</div>';
  if (!modal.open) modal.showModal();

  const cleanUrl = new URL(window.location.href);
  cleanUrl.searchParams.delete('quote_submitted');
  window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
});
